// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SpeakerOff = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M86.901 57.339a2 2 0 1 1-2.828 2.828l-9.236-9.237-9.238 9.237a1.99 1.99 0 0 1-1.414.586 2 2 0 0 1-1.414-3.414l9.237-9.237-9.25-9.249a2 2 0 1 1 2.83-2.828l9.25 9.249 9.248-9.249a2 2 0 1 1 2.828 2.828l-9.249 9.249 9.236 9.237ZM46.398 69.08 28.605 58.696a2.003 2.003 0 0 0-1.008-.272H12.5V37.576h15.097c.355 0 .702-.093 1.008-.272l17.793-10.385V69.08Zm2.996-47.379a2.004 2.004 0 0 0-2.004.007L27.056 33.576H10.5a2 2 0 0 0-2 2v24.848a2 2 0 0 0 2 2h16.556L47.39 74.291a1.996 1.996 0 0 0 2.004.007 2 2 0 0 0 1.004-1.734V23.436c0-.716-.383-1.378-1.004-1.735Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default SpeakerOff;
